var map = {
	"./da-DK/guest-area.json": 767,
	"./de-DE/guest-area.json": 768,
	"./el-GR/guest-area.json": 769,
	"./en-GB/guest-area.json": 770,
	"./es-ES/guest-area.json": 771,
	"./et-EE/guest-area.json": 772,
	"./fi-FI/guest-area.json": 773,
	"./it-IT/guest-area.json": 774,
	"./nl-NL/guest-area.json": 775,
	"./no-NO/guest-area.json": 776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 766;